import React from 'react';
import Carousel from '../Carousel';
import gallery1 from '../../images/gallery/gallery1.png';
import gallery2 from '../../images/gallery/gallery2.png';
import gallery3 from '../../images/gallery/gallery3.png';
import gallery4 from '../../images/gallery/gallery4.png';
import gallery5 from '../../images/gallery/gallery5.png';

const gallery = [
  { id: 1, src: gallery1, alt: 'gallery1' },
  { id: 2, src: gallery2, alt: 'gallery2' },
  { id: 3, src: gallery3, alt: 'gallery3' },
  { id: 4, src: gallery4, alt: 'gallery4' },
  { id: 5, src: gallery5, alt: 'gallery5' },
];

const Gallery = () => (
  <div id="gallery" className="bg-techsicoGray-200">
    <div className="flex flex-col mx-5.5 my-12 md:flex-row md:mx-12 lg:mx-15 lg:my-20 2xl:mx-24 2xl:my-18 3xl:mx-33 3xl:my-28">
      <div className="flex items-center md:my-9 md:ml-9 lg:ml-11">
        <Carousel
          circular
          innerBottomRight
          buttonShadow
          className="w-full h-44 md:w-58 lg:w-79 lg:h-59 2xl:w-154 2xl:h-103 3xl:w-154 3xl:h-103"
        >
          {gallery.map(({ id, src, alt }) => (
            <img
              key={id}
              src={src}
              alt={alt}
              className="rounded-2xl w-full h-full object-cover"
            />
          ))}
        </Carousel>
      </div>
      <div className="my-6 md:mx-6 lg:mx-12 flex flex-col items-start justify-center 3xl:mx-22">
        <h2 className="mb-4 font-montserrat font-bold text-2xl leading-1.2em lg:text-4xl lg:leading-1.2em 2xl:text-5xl 2xl:leading-1.2em 3xl:text-6.3xl">
          Gallery
        </h2>
        <p className="mb-6 font-montserrat leading-1.55em text-techsicoGray-400 md:w-87 lg:text-lg lg:mb-8 lg:w-113 2xl:text-2xl 2xl:w-142 2xl:mb-12 2xl:leading-1.55em 3xl:text-3.5xl 3xl:w-216">
          Techsico Enterprise has worked on a variety of projects across our
          service area. Here is a sample of some of the work we have done. Each
          solution delivered was completed with care and precision.
        </p>
      </div>
    </div>
  </div>
);

export default Gallery;
